import { personalDateOf } from '@wiztime/core';
import { Navigate } from 'react-router';
import { useServices } from '../hooks/useServices';
import { useSettingsState } from '../hooks/useSettings';
import { dayPath } from './routes';

/** `#/` goes to today's personal date; waits for the settings so the day start is right. */
export function RootRedirect() {
  const { now } = useServices();
  const { data } = useSettingsState();
  if (data === undefined) return null;
  return <Navigate to={dayPath(personalDateOf(now(), data.dayStartMin))} replace />;
}
